/* @ngInject */
const persoWritter = (
  matcher,
  genericOptions,
  simpleOptions,
  excelUtils,
  excelStyles,
  $filter
) => {
  const self = {}

  const defaultOptions = {
    title: 'Mon document',
    data: [],
    sortOrder: [],
    rowHeight: 15,
  }

  self.download = (name, data, options) => {
    return self.generate(name, data, options)
      .then((blob) => {
        excelUtils.downloadWorkbook(blob, options.title)
      })
      .catch((err) => {
        console.error(err.message || err)
        throw err
      })
  }

  self.generate = (name, data, options) => {
    options = self.getOptions(name, options)
    return excelUtils.getWorkbook(options.filename)
      .then((workbook) => {
        const sheet = workbook.sheet(0)
        sheet.active(true)
        data = $filter('orderBy')(data, options.sortOrder)
        self.writeSheet(sheet, data, options)

        return workbook.outputAsync({
          type: '',
        })
      })
      .catch((err) => {
        console.error(err.message || err)
        throw err
      })
  }

  self.writeSheet = (sheet, data, options) => {
    let rowIndex = 0
    self.writeHeaders(sheet, options)

    for (let index = 0; index < data.length; index++) {
      const item = data[index]
      options.currentRow = options.firstRow + rowIndex + 1
      self.writeRow(sheet, item, options)
      rowIndex++
    }

    if (options.enableTitle) {
      self.writeTitle(sheet, options)
    }

    self.setFitWidth(sheet, data, options)
  }

  self.writeRow = (sheet, item, options) => {
    let colIndex = 0

    for (const key in options.fields) {
      const field = options.fields[key]
      if (field && field.output && field.output.excel && field.output.excel.display) {
        const cell = sheet.cell('' + excelUtils.integerToLetter(colIndex) + options.currentRow)

        excelUtils.setCellValue(cell, item[field.ref], field.type)
        cell.style(excelStyles.bodyCell())

        if (options.enableColor) {
          excelUtils.setColorStyles(cell, item, field.ref)
        }
        colIndex++
      }
    }

    sheet.row(options.currentRow).height(options.rowHeight)
  }

  self.writeTitle = (sheet, { fields, title, }) => {
    sheet.row(1).height(60)
    sheet.row(2).height(8)
    const colNumber = excelUtils.howManyValidFields(fields)
    const range = excelUtils.getRange(sheet, 1, 1, 0, colNumber - 2)
    range.style(excelStyles.titleRange)
    sheet.cell('B1').value(title)
    range.merged(true)

    sheet.cell('A1').style(excelStyles.titleImage)
  }

  self.writeHeaders = (sheet, { fields, firstRow, }) => {
    let colIndex = 0

    for (const key in fields) {
      const field = fields[key]
      if (field.output && field.output.excel && field.output.excel.display) {
        const cell = excelUtils.getCell(sheet, firstRow, colIndex)
        cell.value(field.label || '')
        cell.style(excelStyles.headerCell)
        colIndex++
      }
    }
  }

  self.setFitWidth = (sheet, data, { fields, firstRow, }) => {
    let colIndex = 0

    for (const fieldName in fields) {
      const field = fields[fieldName]
      if (field && field.output && field.output.excel && field.output.excel.display) {
        excelUtils.setFitColWidth(sheet, colIndex, firstRow, data.length, fieldName)
        colIndex++
      }
    }
  }

  self.getOptions = (name, options = {}) => {
    if (matcher.contain(name, 'perso|generic')) {
      return genericOptions.generateOptions(options)
    } else if (matcher.contain(name, 'simple|Simple|blank|Blank')) {
      return simpleOptions.generateOptions(options)
    } else {
      return defaultOptions
    }
  }

  return self
}
export default persoWritter



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/excel/perso/persoExcel.service.js